<template>
  <div>
    <div class="data-box" v-if="page.currentItem">
      <component :is="page.currentItem.type+'Editor'"></component>
    </div>
  </div>
</template>
<script>
import swiperEditor from './editors/swiperEditor'
import imagesEditor from './editors/imagesEditor'
import collapseEditor from './editors/collapseEditor'
import richtextEditor from './editors/richtextEditor'
import videoPlayerEditor from './editors/videoPlayerEditor'
import wtitleEditor from './editors/wtitleEditor'
import peopleEditor from './editors/peopleEditor'
import descriptionEditor from './editors/descriptionEditor'
import movieEditor from './editors/movieEditor'
import peopleDescribeEditor from './editors/peopleDescribeEditor'
import interviewEditor from './editors/interviewEditor'
import interviewVideoEditor from './editors/interviewVideoEditor'
import guestEditor from './editors/guestEditor'
import talkListEditor from './editors/talkListEditor'
import screeningListEditor from './editors/screeningListEditor'
import moviePanoramaEditor from './editors/moviePanoramaEditor'
import movieTrackEditor from './editors/movieTrackEditor'
import discussionEditor from './editors/discussionEditor'
import topicEditor from './editors/topicEditor'

export default {
  name: 'dataBox',
  components: {
    swiperEditor,
    imagesEditor,
    collapseEditor,
    richtextEditor,
    videoPlayerEditor,
    wtitleEditor,
    peopleEditor,
    descriptionEditor,
    movieEditor,
    peopleDescribeEditor,
    interviewEditor,
    interviewVideoEditor,
    guestEditor,
    talkListEditor,
    screeningListEditor,
    moviePanoramaEditor,
    movieTrackEditor,
    discussionEditor,
    topicEditor
  },
  computed: {
    page () {
      return this.$store.state.page
    }
  }
}
</script>
<style lang="less" scoped>
.data-box {
  width: 600px;
  min-height: 70px;
  padding: 15px;
  margin-top: 10px;
  border: 1px solid #dddddd;
  border-radius: 10px;
  position: relative;
  background-color: #fff;
  .point-out {
    width: 10px;
    height: 10px;
    background-color: #ffffff;
    border-bottom: 1px solid #DCDFE6;
    border-left: 1px solid #DCDFE6;
    transform: rotate(45deg);
    position: absolute;
    top: 15px;
    left: -6px;
  }
  /deep/ .el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/components/dataBox.vue